import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ cooldownEndsAt, onExpire }) => {
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    const calculateTimeLeft = () => {
      if (!cooldownEndsAt) {
        return '00:00:00';
      }

      const diff = cooldownEndsAt - Date.now();
      if (diff <= 0) {
        onExpire?.();
        return '00:00:00';
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [cooldownEndsAt, onExpire]);

  return (
    <div className="font-mono text-xl font-bold text-purple-600 mt-1">
      {timeLeft}
    </div>
  );
};

export default CountdownTimer;
